// @ngInject
function userPrintQRCodeDialogService($uibModal, UsersApiService){
    return {
        showDialog: showDialog
    };

    function showDialog(user){
        var modalDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'userPrintQRCodeDialogController as vm',
            templateUrl: 'main/contacts/users/userPrintQRCodeDialog/userPrintQRCodeDialog.tpl.html',
            size: 'sm',
            resolve: {
                user: function (){
                    return user;
                }
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function userPrintQRCodeDialogController($scope, $rootScope, user, $uibModalInstance, UsersApiService, loadSpinnerService, ToasterService, $translate) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;
    vm.username = user.username;
    vm.userId = user.id;
    vm.fullName = user.firstName + ' ' + user.lastName;
    vm.password = ""
    vm.ongoingRequest = false;
    vm.reveal = false;
    vm.closeModal = closeModal;
    vm.authenticateAndPrint = authenticateAndPrint; 

    activate();
    
    function activate() {    
    }

    function authenticateAndPrint(){
        if(vm.ongoingRequest)
            return;
        
        loadSpinnerService.start('mainSpinner');
        vm.ongoingRequest = true;
        UsersApiService.printQRCode(vm.userId, vm.password).then(function(response) {
            vm.closeModal();
        }, function(error) {
            ToasterService.showError($translate.instant(error.statusText), $translate.instant('common.error'));
        }).finally(function() {
            vm.ongoingRequest = false;
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function closeModal() {
        $uibModalInstance.close();
    }
}

angular
    .module('contacts.users.userPrintQRCodeDialog', [])
    .service('userPrintQRCodeDialogService', userPrintQRCodeDialogService)
    .controller('userPrintQRCodeDialogController', userPrintQRCodeDialogController);